import { useContext, useCallback, useState, useMemo } from 'react';
import GridLoading from '../../../components/grid-loading';
import baseColumns from './columns';
import style from '../../grid-page.module.less';
import PresetGroupsGridPlaceholder from './grid-placeholder';
import { PresetGroupsContext } from './context';
import { baseColumnsDefaultConfigs } from './columns/columnConfig';
import { HooksDisplayGrid } from 'ui-components/components/hooks-display-grid';
import ErrorBoundary from '../../../components/error-boundary';

const getColumnId = ({ id }) => id;

const buildColumns = (columnConfig) =>
  columnConfig.reduce((acc, col) => {
    const colToRender = baseColumns[col.id];
    if (colToRender) {
      acc.push({
        ...col,
        name: colToRender.name,
        render: colToRender.render,
      });
    }
    return acc;
  }, []);

const PresetGroupGrid = () => {
  const [selectedPresetGroupIds, setSelectedPresetGroupIds] = useState([]);
  const { presetGroupIds, isLoading, setDirection } = useContext(PresetGroupsContext);
  const [gridColumns, setGridColumns] = useState(buildColumns(baseColumnsDefaultConfigs));

  const onColumnsChanged = useCallback((columns) => {
    setGridColumns(buildColumns(columns));
  }, []);

  const gridData = useMemo(() => presetGroupIds?.map((id) => ({ id })), [presetGroupIds]);

  const onOrderByChanged = useCallback(
    (columns) => {
      const { sorted: sortDirection } = columns.find((col) => col.sorted);
      setDirection(sortDirection);
      setGridColumns(buildColumns(columns));
    },
    [setDirection],
  );

  return (
    <div className={style.grid}>
      {isLoading && <GridLoading />}
      <ErrorBoundary errorMessageId='inventoryGrid'>
        <HooksDisplayGrid
          columns={gridColumns}
          data={gridData}
          getColumnId={getColumnId}
          onColumnsChanged={onColumnsChanged}
          onOrderByChanged={onOrderByChanged}
          onSelectedChanged={setSelectedPresetGroupIds}
          placeholder={isLoading ? null : <PresetGroupsGridPlaceholder />}
          selected={selectedPresetGroupIds}
        />
      </ErrorBoundary>
    </div>
  );
};

export default PresetGroupGrid;
